export const DELIVERY_TIME_ZONES = [
  { label: '指定なし',  sagawaCode: '',   yamatoCode: '0'    },
  { label: '午前中',    sagawaCode: '01', yamatoCode: '0812' },
  { label: '12〜14時', sagawaCode: '02', yamatoCode: '0'    }, // ヤマト非対応のため指定なしにフォールバック
  { label: '14〜16時', sagawaCode: '03', yamatoCode: '1416' },
  { label: '16〜18時', sagawaCode: '04', yamatoCode: '1618' },
  { label: '18〜20時', sagawaCode: '05', yamatoCode: '1820' },
  { label: '20〜21時', sagawaCode: '06', yamatoCode: '2021' },
]

export const getSagawaTimeCode = (label: string): string =>
  DELIVERY_TIME_ZONES.find((z) => z.label === label)?.sagawaCode ?? ''

export const getYamatoTimeCode = (label: string): string =>
  DELIVERY_TIME_ZONES.find((z) => z.label === label)?.yamatoCode ?? '0'
